// extracted by mini-css-extract-plugin
module.exports = {"label_spec":"patientSearch_label_spec__7TH9o","search_icon_image":"patientSearch_search_icon_image__394ak","pl40":"patientSearch_pl40__2LPHl"};